import * as firebase from 'firebase/app';
import 'firebase/analytics';

import logger       from '@/lib/logger';
import { UsageModel } from '@/models/usage';
import { Repository } from "@/db/_repo";
const db = new Repository();

/* tslint:disable:no-string-literal triple-equals */
const pingers = {
    datadog: true,
    google: true,
    custom: true,
    firebase: true,
    console: (window['DD_SERVICE_NAME'] == 'quizMe.dev'),
};

export enum DeckUsage {
    add = 'DECKS_ADD',
    open = 'DECKS_OPEN',
    openedit = 'DECKS_OPENEDIT',
    modify = 'DECKS_MODIFY',
    delete = 'DECKS_DELETE',
    share = 'DECKS_SHARE',
    export = 'DECKS_EXPORT',
    import = 'DECKS_IMPORT',
    addcard = 'DECKS_ADDCARD',
    deletecard = 'DECKS_DELETECARD',
}

export enum UserUsage {
    signup = 'USER_SIGNUP',
    signin = 'USER_SIGNIN',
    deleteAccount = 'USER_DELETEACCOUNT',
    starttour = 'USER_STARTTOUR',
    skiptour = 'USER_SKIPTOUR',
    loadprofile = 'USER_LOADPROFILE',
    skipwelcome = 'USER_SKIPWELCOME',
    clicktrial = 'USER_CLICKTRIAL',

}

export enum SubscriptionUsage {
    start = 'SUB_START',
    reject = 'SUB_REJECT',
    checkout = 'SUB_CHECKOUT',
    deckpaywall = 'SUB_INAPPPAYWALL_DECK',
    cardpaywall = 'SUB_INAPPPAYWALL_CARD'
}

export enum LearningUsage {
    start = 'LEARN_START',
    complete = 'LEARN_COMPLETE',
    abandon = 'LEARN_ABANDON',
    anyway = 'LEARN_ANYWAY',
}

export type UsageT = DeckUsage | UserUsage | SubscriptionUsage | LearningUsage;

export interface UsageType {
    type: UsageT;
    ts?: any;
    uid: string;
}

export function send(usage: UsageType) {
    if (!usage.ts) { usage.ts = db.now }
    if (pingers.datadog)    logger.methods.logInfo(`Usage Ping: ${usage.type.toString()}`, { usage_details: usage, toDate: db.toDate(usage.ts) });
    if (pingers.custom)     writeDB(usage);
    if (pingers.console)    console.log("Usage ping", usage);
    if (pingers.firebase)   firebase.analytics().logEvent(usage.type.toString());
}

function writeDB(usage: UsageType) {
    const usageRec: UsageModel = {
        userId: usage.uid,
        type: usage.type.toString(),
        ts: usage.ts,
        path: window.location.pathname,
        sessionId: document.cookie.match(/_dd=[^;]+/)[0].replace('_dd=', ''),
        service: window['DD_SERVICE_NAME']
    }
    db.usage.addUsage(usageRec)
}

export const mixin = {
    methods: {
        sendUsagePing: send,
    }
}